import styled from "styled-components";

import { theme } from "../../themes/themes";
export const GeneralStyle = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.neutral.gray[200]};
  hr {
    height: 20px;
    width: 1px;
  }
`;

export const ContentHeader = styled.div`
  width: 100%;
  height: 100%;
  padding-top: 25px;
  padding-bottom: 20px;
  padding-left: 20px;
`;

export const ContentTitle = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  label {
    margin: 0 10px;
  }
  .title {
    font-size: 16px;
    color: ${({ theme }) => theme.primary.purple};
    font-weight: 600;
  }
  .mandatory-info {
    font-size: 14px;
    color: ${({ theme }) => theme.neutral.gray[2600]};
    font-weight: 400;
  }
  button {
    right: 15px;
    position: absolute;
  }
`;
export const CloseButton = styled.div`
  width: 100%;
  height: 100%;
`;
export const ContentForm = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: minmax(30%, 300px) minmax(30%, 300px) 1fr;
  grid-column-gap: 10px;
  padding-bottom: 40px;
  padding-left: 30px;
  .form-label {
    font-weight: 600;
    color: ${({ theme }) => theme.primary.purple};
  }
  .save-icon {
    align-self: center;
    margin-top: 25px;
    color: ${({ theme }) => theme.primary.purple};
    cursor: pointer;
  }
`;
export const TextField = styled.div``;

export const SelectField = styled.div`
  z-index: 10;
`;
